// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__ECclm","tableContainer":"Table_tableContainer__fOWFH","loaderContainer":"Table_loaderContainer__j0r2C","loader":"Table_loader__1MX0Y"};